import { GlobalFieldNames } from '../../types';
import type { UnderwriteQuoteState } from '../../views/underwriter/types';

export function formatRaterOptions(
  carriers: UnderwriteQuoteState['carriers'],
  quote: UnderwriteQuoteState['quote'],
  raterX: UnderwriteQuoteState['raterX']
) {
  return {
    [GlobalFieldNames.carrier]: {
      options: carriers?.carriers ?? [],
      value: quote.quote.treatyId,
    },
    [GlobalFieldNames.productVersion]: {
      options: [raterX.productVersion],
      value: raterX.productVersion,
    },
  };
}

const mergeRaterOptionsIntoState = <T extends UnderwriteQuoteState>(
  data: T
) => {
  const raterOptions = formatRaterOptions(
    data.carriers,
    data.quote,
    data.raterX
  );
  return {
    ...data,
    raterOptions,
  };
};

export default mergeRaterOptionsIntoState;
